import { useMapsLibrary } from "@vis.gl/react-google-maps";
import React from "react";

const CommonMapContext = React.createContext({});

const CommonMapProvider = ({ children }) => {
  const [map, setMap] = React.useState(null);
  const [center, setCenter] = React.useState();
  const [zoom, setZoom] = React.useState();
  const [heading, setHeading] = React.useState();
  const [current, setCurrent] = React.useState(null);
  const [selectedFloorplan, setSelectedFloorplan] = React.useState(null);
  const [floorplanImage, setFloorplanImage] = React.useState(null);
  const [editFloorplanEnabled, setEditFloorplanEnabled] = React.useState(false);
  const [focusedObject, setFocusedObject] = React.useState(null);
  const [showAllLabelsToggle, setShowAllLabelsToggle] = React.useState(false);
  const [following, setFollowing] = React.useState(false);

  const mapLibCore = useMapsLibrary("core");
  const mapLibMaps = useMapsLibrary("maps");
  const mapLibMarker = useMapsLibrary("marker");
  const mapLibGeometry = useMapsLibrary("geometry");
  const mapLibPlaces = useMapsLibrary("places");

  return (
    <CommonMapContext.Provider
      value={{
        map,
        mapLibCore,
        mapLibMaps,
        mapLibMarker,
        mapLibGeometry,
        mapLibPlaces,
        setMap,
        center,
        setCenter,
        zoom,
        setZoom,
        heading,
        setHeading,
        current,
        setCurrent,
        selectedFloorplan,
        setSelectedFloorplan,
        floorplanImage,
        setFloorplanImage,
        focusedObject,
        setFocusedObject,
        editFloorplanEnabled,
        setEditFloorplanEnabled,
        showAllLabelsToggle,
        setShowAllLabelsToggle,
        following,
        setFollowing,
      }}
    >
      {children}
    </CommonMapContext.Provider>
  );
};

export { CommonMapProvider, CommonMapContext };
